import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetTacticalAssignmentRequest = (hubList, userName, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IpAssignment/TacticalAssignment`,
	params: { hubList, userName, userId }
});

export const GetStrategicAssignmentRequest = (hubList, userName, userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}IpAssignment/StrategicAssignment`,
	params: { hubList, userName, userId }
});
